var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1a4708ab5614d87747b24ae4c06bfeb82bb81e00"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lifeworkcalendar@reclaimai"]={id:"1a4708ab5614d87747b24ae4c06bfeb82bb81e00"};
      